import { getApp } from 'firebase/app';
import { getAuth, getIdToken, User } from 'firebase/auth';

const getCurrentAuthUser = (): User | null => {
  return getAuth(getApp()).currentUser;
};

const getCurrentAuthToken = async (): Promise<string | null> => {
  const currentUser = getCurrentAuthUser();

  if (!currentUser) {
    return null;
  }

  return getIdToken(currentUser);
};

export const getAuthHeaders = async (): Promise<Record<string, string>> => {
  const token = await getCurrentAuthToken();
  return token ? { authorization: `Bearer ${token}` } : {};
};
